import { IonToolbar } from '@ionic/react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import claroLogo from '../../assets/images/claro.png'
import failedImg from '../../assets/images/error.svg'
import { useAppContext } from '../../context/AppContext'
import { useStepsContext } from '../../context/StepsContext'
import { procedureComplete } from '../../redux/actions'
import Button from '../Button'

const ActiveLinesError = () => {
  const { setBlockNavigation }: any = useAppContext()
  const history = useHistory()

  const dispatch = useDispatch()
  const { resetSteps }: any = useStepsContext()

  const onGoBack = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures')
    setBlockNavigation(false)
  }

  return (
    <main className="landing">
      <header id="procedure-toolbar">
        <IonToolbar>
          <img src={claroLogo} alt="back page button" className="max-height-22 ion-padding-start" />
        </IonToolbar>
      </header>
      <div className="landing-container">
        <img src={failedImg} alt="activation failed" style={{ height: '150px' }} />
        <h3>
          <strong>
            No es posible activar <br /> más lineas
          </strong>
        </h3>
        <p className="error-sugest" style={{ color: '#6A6A6A' }}>
          Para continuar activando líneas Claro acercate a un centro de atención.
        </p>
        <Button
          id="prepaga-failed-back-to-start"
          className="link-button"
          label="VOLVER AL INICIO"
          handleSubmit={onGoBack}
        />
      </div>
    </main>
  )
}

export default ActiveLinesError
